module.exports = __webpack_public_path__ + "img/start01.5f63ffa8.jpg";